import React from 'react'

const SvgIconMinusCircle = (props) => (
  <svg viewBox="0 0 22 22" fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11 2a9 9 0 1 0 0 18 9 9 0 0 0 0-18zM0 11C0 4.925 4.925 0 11 0s11 4.925 11 11-4.925 11-11 11S0 17.075 0 11z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6 11a1 1 0 0 1 1-1h8a1 1 0 1 1 0 2H7a1 1 0 0 1-1-1z"
      fill="currentColor"
    />
  </svg>
)

export default SvgIconMinusCircle
